import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { LoginForgotPassword } from 'components/loginForgotPassword';
import navigationPaths from 'engine/navigationPaths';
import { OEM } from 'utility/OEMProvider';
import { resources } from 'oems/resources';

import * as Styled from './logonPage.styles';

export default function LogonPage() {
  const navigate = useNavigate();

  const onLoggedIn = () => {
    navigate(navigationPaths().Invoices);
  };

  return (
    <Styled.Wrapper>
      <img src={resources.logoDarkImage} alt="logo" className="logo" />
      <Styled.FormWrapper>
        <div className="content">
          <Styled.Title>
            Witaj ponownie,
            <br />
            zaloguj się do konta
          </Styled.Title>

          <p>
            Nie masz konta w {OEM().ProductName}? <Link to={navigationPaths().Register}>Zarejestruj się</Link>
          </p>

          <LoginForgotPassword onSuccess={onLoggedIn} />

          <p className="forgotPassword">
            <Link to={navigationPaths().ForgotPassword}>Zapomniałeś hasło?</Link>
          </p>
        </div>

        <Styled.Copyright>{OEM().Copyright}</Styled.Copyright>
      </Styled.FormWrapper>

      <Styled.Description>
        <Styled.Title>Faktury automatyczne</Styled.Title>
        <p>Dzięki automatycznym fakturom, nie będziesz musiał pamiętać o wystawieniu dokumentów w każdym miesiącu.</p>
        <img src={resources.loginImage} alt="" />
      </Styled.Description>
    </Styled.Wrapper>
  );
}
